module.exports = __webpack_public_path__ + "img/logo.f99ccde8.svg";